import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { enableMouseControls } from '../../actions/app';

const mapDispatchToProps = { enableMouseControls };

function withMouseControls(WrappedComponent) {
  const WithMouseControls = (props) => {
    useEffect(() => {
      const { enableMouseControls } = props;

      enableMouseControls(true);
      return () => enableMouseControls(false);
    }, [props]);
    return <WrappedComponent {...props} />;
  };

  return connect(null, mapDispatchToProps)(WithMouseControls);
}

export default withMouseControls;
